import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { document.title = "Admin | Sambiva"; }, []);
  useEffect(() => { if (user && user.role === "admin") navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const data = await login(email, password);
      if (data.role !== "admin") { setError("This login is for administrators only."); setLoading(false); return; }
      navigate("/admin");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || "Login failed"); setLoading(false); }
  };

  const field = "w-full px-4 py-3 rounded-xl border border-black/10 bg-white focus:outline-none focus:ring-2 focus:ring-sambiva-green/40 text-sm";

  return (
    <div className="min-h-screen flex items-center justify-center bg-sambiva-deepgreen p-6">
      <div className="w-full max-w-sm bg-white rounded-3xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="text-2xl font-extrabold tracking-tight text-sambiva-charcoal">sambiva</span>
          <span className="text-[10px] font-bold uppercase tracking-widest text-white bg-sambiva-green px-1.5 py-0.5 rounded">Admin</span>
        </div>
        <h1 className="text-xl font-semibold text-sambiva-charcoal mb-1">Sign in to Admin</h1>
        <p className="text-sambiva-muted text-sm mb-6 flex items-center gap-1"><ShieldCheck size={14} /> Secure administrator access</p>
        {error && <div data-testid="admin-login-error" className="mb-4 bg-sambiva-red/10 text-sambiva-red rounded-xl px-4 py-3 text-sm">{error}</div>}
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input data-testid="admin-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <input data-testid="admin-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
          <button data-testid="admin-login-submit" disabled={loading} className="w-full bg-sambiva-green hover:bg-sambiva-deepgreen text-white font-semibold py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60 transition-colors">
            {loading && <Loader2 className="animate-spin" size={18} />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
